import { Card, Row, Col, Button, Modal } from "react-bootstrap";
import MainLayout from "../../layout/MainLayout";
import MessengerBox from "../../components/Messenger/MessengerBox";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { resetSession, selectUserSession } from "../../store/features/session/userSession";
import SharedBoxAPI from "../../api/endpoints/SharedBox";
import cacheManager from "../../store/CacheManager";
import { CompanyDomainTypes, SharedBox, SharedBoxMessage, SharedBoxRecipient } from "../../types/SharedBox";
import { SharedBoxSmartUpdate } from "../../helpers/SharedBox";
import { useParams } from "react-router";
import { useAppDispatch } from "../../store/hooks";
import { IsExtraSmall, IsSmallScreenExclusive } from "../../helpers/Frame";
import ModalSupport from "../../components/Common/ModalSupport";

// const REFRESH_HOOK_INTERVAL = 1000 * 30;
const REFRESH_HOOK_INTERVAL = 1000 * 15; // Demo purpose

const FILE_INFO = {
    fileSize: '3MB'
};

const BOX_MIN_SIZE = 'justify-content-center h-100 m-0';
const BOX_NORMAL_SIZE = 'justify-content-center h-100 m-0';

export const HomePage = () => {
    const routeParams = useParams() || {};
    const dispatch = useAppDispatch();
    const [compGState] = useState<any>({});
    const [isMobileView, setMobileView] = useState<boolean>(true);
    const [supportModalStatus, setSupportModalStatus] = useState<boolean>(false);
    const [sharedBox, setSharedBox] = useState<SharedBox|null>(null);
    const [messages, setMessages] = useState<Array<SharedBoxMessage>>([]);
    const [recipients, setRecipients] = useState<{
        [key: string]: SharedBoxRecipient;
    }>({});
    const userSession = useSelector(selectUserSession);
    const handleResizeBox = () => {
        setMobileView(IsExtraSmall() || IsSmallScreenExclusive() || false);
    };
    useEffect(() => {
        handleResizeBox();
        window.addEventListener('resize', handleResizeBox);
        return () => {
            window.removeEventListener('resize', handleResizeBox);
        };
    }, []);
    const refreshSharedBox = async (sharedBox: SharedBox|null, isNew: boolean = false) => {
        try {
            const sharedBoxEntry = await SharedBoxAPI.getSharedBox();
            const sb = await SharedBoxSmartUpdate(sharedBox || {}, sharedBoxEntry, isNew === true);
            compGState.sharedBox = sb;
            setSharedBox(sb);
            setMessages(sb.messages);
            setRecipients(sb.recipientDictionary || {});
        } catch (e: any) {
            console.error(e);
        }
    };
    useEffect(() => {
        const sharedBoxIdFromParams = routeParams.sharedBoxId;
        if (sharedBoxIdFromParams) {
            const sharedBoxID = (userSession || {}).sharedBoxID;
            // console.log('sharedBoxIdFromParams:', sharedBoxIdFromParams, sharedBoxID);
            if (sharedBoxIdFromParams != sharedBoxID) {
                dispatch(resetSession());
                window.location.reload();
                return;
            }
        }
        refreshSharedBox(sharedBox, false);
        const pid = setInterval(() => {
            refreshSharedBox(compGState.sharedBox, true);
        }, REFRESH_HOOK_INTERVAL);
        return () => {
            clearInterval(pid);
        };
    }, [(userSession || {}).sharedBoxID]);
    return (
        <MainLayout
            onSupportModalClicked={setSupportModalStatus}
        >
            <Row className={isMobileView ? BOX_MIN_SIZE : BOX_NORMAL_SIZE}>
                <Col
                    xs={12} sm={12} md={10} lg={8}
                    className={isMobileView ? ' px-0 ' : ' '}
                >
                    <div className="d-none d-sm-block display-5 mb-3 mt-3" id="conversation-title-header">{sharedBox ? sharedBox.label : null}</div>
                    <Card className={'shadow ' + (isMobileView ? '' : ' mb-5 ')} style={{}}>
                        <Card.Header id="messenger-header">
                            <div className="d-none d-sm-block">
                                <div className="d-flex flex-row">
                                    <div>Conversation</div>
                                    <div className="d-flex flex-grow-1 justify-content-end">
                                        <Button
                                            onClick={() => setSupportModalStatus(true)}
                                            variant="link"
                                            className="p-0 m-0">Need support?</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="d-block d-sm-none">{sharedBox ? sharedBox.label : null}</div>
                        </Card.Header>
                        <Card.Body id="messenger-body-box">
                            <MessengerBox
                                isMobileView={isMobileView}
                                sharedBox={sharedBox}
                                refreshSharedBox={() => refreshSharedBox(compGState.sharedBox, true)}
                                messages={messages}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalSupport
                supportModalStatus={supportModalStatus}
                setSupportModalStatus={setSupportModalStatus}
            />
        </MainLayout>
    );
};

export default HomePage;